import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import { AdProviders, ADUNIT_MAP } from '../../constants';
import { useAdUnit } from '../../useAdUnit';
const MobileGridDisplayDynamic300x250 = /*#__PURE__*/ React.memo(({ safety ='off' , rowId  })=>{
    const _useAdUnit = useAdUnit(AdProviders.Gak, `${ADUNIT_MAP['MobileGridDisplayDynamic300x250']}-${rowId}`, safety, {
        refreshLimit: 30,
        refreshTimeout: 30000,
        size: [
            300,
            250
        ]
    }), { advertIsOff  } = _useAdUnit, slotAttr = _object_without_properties(_useAdUnit, [
        "advertIsOff"
    ]);
    if (advertIsOff) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", _extends({}, slotAttr));
}, (last, next)=>{
    return last.safety === next.safety && last.rowId === next.rowId;
});
MobileGridDisplayDynamic300x250.displayName = 'MobileGridDisplayDynamic300x250';
export default MobileGridDisplayDynamic300x250;
